import { render, staticRenderFns } from "./v-2.vue?vue&type=template&id=4ce7c715&scoped=true&"
import script from "./v-2.vue?vue&type=script&lang=js&"
export * from "./v-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7c715",
  null
  
)

export default component.exports